
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import value2name from 'vux/src/filters/value2name.js'


export default {
components:{
Group,
XInput,
XHeader,
XButton,
Cell,
XAddress,
Selector
},
data () {
return {
orgcode:"",
company:'',
estdate:'',
busaddress:'',
Staffnum:'',
industry:'',
legalperson:'',
legalmobile:'',
legalphone:'',
actualperson:'',
actualmobile:'',
actualphone:'',
yunperson:'',
Yunmobile:'',
yunphone:'',
Delvaddress:'',
invoice:{},
execert:'',
authcert:'',
Name:'',
mobile:'',
email:'',
Sequence:'',
eduList:[{key: '是', value: '是'}, {key:'否', value: '否'}]
}
},
methods:{
save (){
if(this.Name != '' && this.mobile != '' && this.email != '' && this.company != '' && this.estdate != '' && this.busaddress != '' && this.Staffnum != '' && this.legalperson != '' && this.legalmobile != '' && this.actualperson != '' && this.actualmobile != '' && this.yunperson != '' && this.Yunmobile != '' && this.Delvaddress != '' && this.invoice != '' && this.Name != '' && this.Name != ''){

}
else {

}
}
},
created () {
let account = localStorage.getItem('account')
let  that =this
this.$http.get('/api/v1/agencies/'+account)
.then(function(res){
that.Name = res.data.detail.name
that.idcard = res.data.detail.idcard
that.mobile = res.data.detail.mobile
})
.catch(function(err){
console.log(err)
})
}
}



// WEBPACK FOOTER //
// ./src/components/addfirmInfo.vue